import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/production/palletized/${packing_house_id}/show_process/${packing_house_process_id}`
    );
  },

  fetchPackageGroup(packing_house_id, id) {
    return RequesterV1.get(
      `packing_house/production/palletized/${packing_house_id}/show_package_group/${id}`
    );
  },

  destroy(packing_house_id, id) {
    return RequesterV1.delete(
      `packing_house/production/palletized/${packing_house_id}/show_package_group/destroy/${id}`
    );
  },

  updateReady(packing_house_id, id) {
    return RequesterV1.post(
      `packing_house/production/palletized/${packing_house_id}/show_package_group/update_ready/${id}`
    );
  },
};
